<script setup>
import { computed, defineProps, onMounted } from 'vue';

const props = defineProps({
  content: {
    type: Object,
    required: true,
    validator: (value) => {
      return value.cont_title && 
             value.cont_youtube && 
             typeof value.cont_social_type === 'number';
    }
  }
});

const openTeamWaizmann = () => {
  window.open(props.content.cont_youtube, '_blank');
};

// Computed properties to determine content type
const isYouTube = computed(() => {
  return props.content.cont_social_type == 1;
});

const isInstagram = computed(() => {
  return props.content.cont_social_type == 2;
});

onMounted(() => {
  if (isInstagram.value && window.instgrm?.Embeds?.process) {
    window.instgrm.Embeds.process();
  }
});
</script>

<template>
  <v-card class="d-flex flex-column">
    <div class="px-3">
      <span v-if="isYouTube">
      <h4>{{content.cont_title}}</h4>
      <span  style="color:#3166a5; font-size:12px; margin: 0;">youtube.com/teamwaizmann | der Channel für ZA & ZFA</span>
    
    </span>
     
    
    </div>

    <div class="social-media-view pa-4">
      <!-- YouTube Content -->
      <div v-if="isYouTube" class="youtube-container">
        <iframe
          :src="content.cont_youtube"
          width="100%"
          height="300"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>

      <!-- Instagram Content -->
      <div v-else-if="isInstagram" class="instagram-container position-relative" style="cursor: pointer;" @click="openTeamWaizmann" >

        <v-icon 
          class="instagram-icon ma-4"
          style="position: absolute; top: 8px; right: 8px; color: #E4405F; font-size: 88px; z-index: 10;"
         
        >
          mdi-instagram
        </v-icon>
        <img
          :src="require(`@/assets/instagram/${content.cont_id}.png`)"
          class="text-white align-end"
         
        />
   
      </div>
    </div>
  </v-card>
</template>

<style scoped>


.instagram-container {
  width: 100%;
  max-width: 540px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  height: 465px;
  overflow: hidden;
}

.youtube-container {
  position: relative;
  width: 100%;
  padding-bottom: 70%; /* Increased height ratio */
}

.youtube-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

:deep(.instagram-media) {
  max-width: 540px !important;
  width: 100% !important;
  min-width: 326px !important;
  margin: 0 auto !important;
  height: 515px !important;
  overflow: hidden !important;
}

.position-relative {
  position: relative;
}

.instagram-icon {
  background: white;
  border-radius: 50%;
  padding: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
</style>
